import { StaleBuildError } from '@psyomics/ui-common';

import { GenericError } from './generic-error';

const reloadPage = () => {
  globalThis.location.reload();
};

type AppErrorFallbackProps = {
  readonly error?: unknown;
};

function AppErrorFallback({ error }: AppErrorFallbackProps) {
  if (!(error instanceof StaleBuildError)) return <GenericError />;

  return (
    <GenericError
      subtitleKey="ui-components.staleBuildError.subtitle"
      titleComponents={{
        refreshLink: <button className="text-blue-500 underline cursor-pointer" onClick={reloadPage} type="button" />,
      }}
      titleKey="ui-components.staleBuildError.title"
    />
  );
}

export { AppErrorFallback, type AppErrorFallbackProps };
